var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcehockeyCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_207)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 391,
    height: 174,
    rx: 48,
    fill: "url(#paint0_radial_198_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6517 8.35205H29.3047V171.64H30.6517V8.35205Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.687 8.35205H369.34V171.64H370.687V8.35205Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.925 3.40527H142.123V176.587H143.925V3.40527Z",
    fill: "#005785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.877 3.40527H256.075V176.587H257.877V3.40527Z",
    fill: "#005785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4027 75.6397C52.9888 75.6397 39.6436 63.8667 39.6436 49.4041C39.6436 34.9415 52.9977 23.1606 69.4027 23.1606C85.8077 23.1606 99.1708 34.9336 99.1708 49.4041C99.1708 63.8746 85.8166 75.6397 69.4027 75.6397ZM69.4027 24.3482C53.7381 24.3482 40.9906 35.5864 40.9906 49.3962C40.9906 63.2061 53.7381 74.4443 69.4027 74.4443C85.0673 74.4443 97.8148 63.2139 97.8148 49.3962C97.8148 35.5785 85.0673 24.3482 69.4027 24.3482Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1126 19.4172H62.7656V23.9943H64.1126V19.4172Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0306 19.4172H74.6836V23.9943H76.0306V19.4172Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1126 74.8062H62.7656V79.3832H64.1126V74.8062Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0306 74.8062H74.6836V79.3832H76.0306V74.8062Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4802 49.3964C71.4802 50.4109 70.5525 51.2288 69.4017 51.2288C68.251 51.2288 67.3232 50.4109 67.3232 49.3964C67.3232 48.3819 68.251 47.564 69.4017 47.564C70.5525 47.564 71.4802 48.3819 71.4802 49.3964Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1381 48.1616H58.4932V46.9662H64.7911V42.5386H66.1381V48.1616Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3121 48.1616H72.6582V42.5386H74.0052V46.9662H80.3121V48.1616Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1381 56.262H64.7911V51.8264H58.4932V50.6389H66.1381V56.262Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0052 56.262H72.6582V50.6389H80.3121V51.8264H74.0052V56.262Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4027 156.84C52.9888 156.84 39.6436 145.067 39.6436 130.604C39.6436 116.141 52.9977 104.368 69.4027 104.368C85.8077 104.368 99.1708 116.141 99.1708 130.604C99.1708 145.067 85.8166 156.84 69.4027 156.84ZM69.4027 105.556C53.7381 105.556 40.9906 116.794 40.9906 130.604C40.9906 144.414 53.7381 155.652 69.4027 155.652C85.0673 155.652 97.8148 144.414 97.8148 130.604C97.8148 116.794 85.0673 105.556 69.4027 105.556Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1126 100.617H62.7656V105.194H64.1126V100.617Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0306 100.617H74.6836V105.194H76.0306V100.617Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1126 156.006H62.7656V160.583H64.1126V156.006Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0306 156.006H74.6836V160.583H76.0306V156.006Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4802 130.604C71.4802 131.611 70.5525 132.436 69.4017 132.436C68.251 132.436 67.3232 131.611 67.3232 130.604C67.3232 129.597 68.251 128.771 69.4017 128.771C70.5525 128.771 71.4802 129.589 71.4802 130.604Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1381 129.361H58.4932V128.174H64.7911V123.738H66.1381V129.361Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3121 129.361H72.6582V123.738H74.0052V128.174H80.3121V129.361Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1381 137.462H64.7911V133.026H58.4932V131.839H66.1381V137.462Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0052 137.462H72.6582V131.839H80.3121V133.026H74.0052V137.462Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.598 75.6397C314.184 75.6397 300.83 63.8667 300.83 49.4041C300.83 34.9415 314.184 23.1606 330.598 23.1606C347.012 23.1606 360.357 34.9336 360.357 49.4041C360.357 63.8746 347.003 75.6397 330.598 75.6397ZM330.598 24.3482C314.925 24.3482 302.177 35.5864 302.177 49.3962C302.177 63.2061 314.925 74.4443 330.598 74.4443C346.272 74.4443 359.01 63.2139 359.01 49.3962C359.01 35.5785 346.263 24.3482 330.598 24.3482Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.308 19.4172H323.961V23.9943H325.308V19.4172Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.226 19.4172H335.879V23.9943H337.226V19.4172Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.308 74.8062H323.961V79.3832H325.308V74.8062Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.226 74.8062H335.879V79.3832H337.226V74.8062Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.677 49.3964C332.677 50.4109 331.74 51.2288 330.598 51.2288C329.456 51.2288 328.52 50.4109 328.52 49.3964C328.52 48.3819 329.447 47.564 330.598 47.564C331.749 47.564 332.677 48.3819 332.677 49.3964Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.332 48.1616H319.688V46.9662H325.985V42.5386H327.332V48.1616Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.498 48.1616H333.854V42.5386H335.201V46.9662H341.498V48.1616Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.332 56.262H325.985V51.8264H319.688V50.6389H327.332V56.262Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.201 56.262H333.854V50.6389H341.498V51.8264H335.201V56.262Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.598 156.84C314.184 156.84 300.83 145.067 300.83 130.604C300.83 116.141 314.184 104.368 330.598 104.368C347.012 104.368 360.357 116.141 360.357 130.604C360.357 145.067 347.003 156.84 330.598 156.84ZM330.598 105.556C314.925 105.556 302.177 116.794 302.177 130.604C302.177 144.414 314.925 155.652 330.598 155.652C346.272 155.652 359.01 144.414 359.01 130.604C359.01 116.794 346.263 105.556 330.598 105.556Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.308 100.617H323.961V105.194H325.308V100.617Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.226 100.617H335.879V105.194H337.226V100.617Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.308 156.006H323.961V160.583H325.308V156.006Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.226 156.006H335.879V160.583H337.226V156.006Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.677 130.604C332.677 131.611 331.74 132.436 330.598 132.436C329.456 132.436 328.52 131.611 328.52 130.604C328.52 129.597 329.447 128.771 330.598 128.771C331.749 128.771 332.677 129.589 332.677 130.604Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.332 129.361H319.688V128.174H325.985V123.738H327.332V129.361Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.498 129.361H333.854V123.738H335.201V128.174H341.498V129.361Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.332 137.462H325.985V133.026H319.688V131.839H327.332V137.462Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.201 137.462H333.854V131.839H341.498V133.026H335.201V137.462Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 116.637C183.337 116.637 169.786 104.691 169.786 90.008C169.786 75.3252 183.337 63.3713 200 63.3713C216.664 63.3713 230.214 75.3173 230.214 90.008C230.214 104.699 216.664 116.637 200 116.637ZM200 64.551C184.086 64.551 171.133 75.9701 171.133 90.0001C171.133 104.03 184.086 115.441 200 115.441C215.915 115.441 228.858 104.03 228.858 90.0001C228.858 75.9701 215.906 64.551 200 64.551Z",
    fill: "#005785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.996 49.3964C154.996 50.4109 154.068 51.2288 152.917 51.2288C151.767 51.2288 150.839 50.4109 150.839 49.3964C150.839 48.3819 151.767 47.564 152.917 47.564C154.068 47.564 154.996 48.3819 154.996 49.3964Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.152 49.3964C249.152 50.4109 248.224 51.2288 247.074 51.2288C245.923 51.2288 244.995 50.4109 244.995 49.3964C244.995 48.3819 245.923 47.564 247.074 47.564C248.224 47.564 249.152 48.3819 249.152 49.3964Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.996 130.604C154.996 131.611 154.068 132.436 152.917 132.436C151.767 132.436 150.839 131.611 150.839 130.604C150.839 129.597 151.767 128.771 152.917 128.771C154.068 128.771 154.996 129.589 154.996 130.604Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.152 130.604C249.152 131.611 248.224 132.436 247.074 132.436C245.923 132.436 244.995 131.611 244.995 130.604C244.995 129.597 245.923 128.771 247.074 128.771C248.224 128.771 249.152 129.589 249.152 130.604Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9824 101.215V100.027C36.2536 100.027 41.3562 95.5289 41.3562 90.0081C41.3562 84.4873 36.2536 79.981 29.9824 79.981V78.7935C36.994 78.7935 42.7032 83.8267 42.7032 90.0081C42.7032 96.1895 36.994 101.223 29.9824 101.223V101.215Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.018 101.215C362.997 101.215 357.297 96.1895 357.297 90.0003C357.297 83.811 362.997 78.7856 370.018 78.7856V79.9732C363.746 79.9732 358.644 84.4716 358.644 90.0003C358.644 95.5289 363.746 100.019 370.018 100.019V101.207V101.215Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.669 3.40527H199.322V176.587H200.669V3.40527Z",
    fill: "#A61724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.079 90.0002C202.079 91.0068 201.142 91.8326 200 91.8326C198.859 91.8326 197.922 91.0068 197.922 90.0002C197.922 88.9935 198.85 88.1599 200 88.1599C201.151 88.1599 202.079 88.9857 202.079 90.0002Z",
    fill: "#005785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.645 5.8667H53.3537C27.5999 5.8667 6.6543 24.3323 6.6543 47.0289V132.971C6.6543 155.667 27.5999 174.133 53.3448 174.133H346.645C372.39 174.133 393.336 155.667 393.336 132.971V47.0289C393.336 24.3323 372.39 5.8667 346.645 5.8667ZM392.256 132.971C392.256 155.141 371.793 173.181 346.645 173.181H53.3537C28.1976 173.181 7.74261 155.141 7.74261 132.971V47.0289C7.74261 24.8592 28.2065 6.81829 53.3537 6.81829H346.654C371.802 6.81829 392.265 24.8592 392.265 47.0289V132.971H392.256Z",
    fill: "url(#paint1_linear_198_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.646 0.95166H53.3539C24.5314 0.95166 1.0791 21.6193 1.0791 47.0291V132.971C1.0791 158.381 24.5314 179.048 53.3539 179.048H346.654C375.477 179.048 398.92 158.381 398.92 132.971V47.0291C398.92 21.6193 375.468 0.95166 346.654 0.95166H346.646ZM393.336 132.971C393.336 155.668 372.39 174.133 346.646 174.133H53.3539C27.609 174.133 6.6634 155.668 6.6634 132.971V47.0291C6.65448 24.3325 27.6001 5.8669 53.3539 5.8669H346.654C372.399 5.8669 393.345 24.3325 393.345 47.0291V132.971H393.336Z",
    fill: "#005785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.646 0H53.3542C23.934 0 0 21.1001 0 47.029V132.971C0 158.908 23.934 180 53.3542 180H346.655C376.075 180 400 158.9 400 132.971V47.029C400 21.1001 376.066 0 346.655 0H346.646ZM398.912 132.971C398.912 158.381 375.459 179.048 346.646 179.048H53.3542C24.5317 179.048 1.07939 158.381 1.07939 132.971V47.029C1.07939 21.6192 24.5317 0.95159 53.3542 0.95159H346.655C375.477 0.95159 398.921 21.6192 398.921 47.029V132.971H398.912Z",
    fill: "url(#paint2_linear_198_207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_198_207",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.5 90) rotate(90) scale(87 195.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_207",
    x1: 6.6543,
    y1: 89.9999,
    x2: 393.336,
    y2: 89.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#295975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_198_207",
    x1: 17.0384,
    y1: 9.94845,
    x2: 361.293,
    y2: 203.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#337DA6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcehockeyCourt);
export default __webpack_public_path__ + "static/media/icehockey-court.f346aa50dfe49b0515fcbf20f7fde924.svg";
export { ForwardRef as ReactComponent };